import plugin_vue3_A0OWXRrUgq from "C:/Users/Viktor/Development/asufin-panel-v2/node_modules/@pinia/nuxt/dist/runtime/plugin.vue3.mjs";
import revive_payload_client_4sVQNw7RlN from "C:/Users/Viktor/Development/asufin-panel-v2/node_modules/nuxt/dist/app/plugins/revive-payload.client.js";
import components_plugin_KR1HBZs4kY from "C:/Users/Viktor/Development/asufin-panel-v2/.nuxt/components.plugin.mjs";
import unhead_KgADcZ0jPj from "C:/Users/Viktor/Development/asufin-panel-v2/node_modules/nuxt/dist/head/runtime/plugins/unhead.js";
import router_jmwsqit4Rs from "C:/Users/Viktor/Development/asufin-panel-v2/node_modules/nuxt/dist/pages/runtime/plugins/router.js";
import prefetch_client_5tzzN0oIVL from "C:/Users/Viktor/Development/asufin-panel-v2/node_modules/nuxt/dist/pages/runtime/plugins/prefetch.client.js";
import plugin_5drvKYmdqw from "C:/Users/Viktor/Development/asufin-panel-v2/node_modules/@dargmuesli/nuxt-cookie-control/dist/runtime/plugin.mjs";
import sentry_client_VdOeuw25Mb from "C:/Users/Viktor/Development/asufin-panel-v2/node_modules/@sentry/nuxt/build/module/runtime/plugins/sentry.client.js";
import sentry_client_config_o34nk2sJbg from "C:/Users/Viktor/Development/asufin-panel-v2/.nuxt/sentry-client-config.mjs";
import plugin_t2GMTTFnMT from "C:/Users/Viktor/Development/asufin-panel-v2/node_modules/@nuxtjs/device/dist/runtime/plugin.mjs";
import chunk_reload_client_UciE0i6zes from "C:/Users/Viktor/Development/asufin-panel-v2/node_modules/nuxt/dist/app/plugins/chunk-reload.client.js";
import payload_client_yVLowv6hDl from "C:/Users/Viktor/Development/asufin-panel-v2/node_modules/nuxt/dist/app/plugins/payload.client.js";
export default [
  plugin_vue3_A0OWXRrUgq,
  revive_payload_client_4sVQNw7RlN,
  components_plugin_KR1HBZs4kY,
  unhead_KgADcZ0jPj,
  router_jmwsqit4Rs,
  prefetch_client_5tzzN0oIVL,
  plugin_5drvKYmdqw,
  sentry_client_VdOeuw25Mb,
  sentry_client_config_o34nk2sJbg,
  plugin_t2GMTTFnMT,
  chunk_reload_client_UciE0i6zes,
  payload_client_yVLowv6hDl
]